import { Sutl } from '../../../../sutl';
import { Observable, ObservableCollection } from './Observable';
export class State {
    constructor(defaultValue) {
        this.defaultValue = defaultValue;
        this.observable = new Observable('after');
        this._value = defaultValue;
    }
    get numSubscriptions() {
        return this.observable.numListeners;
    }
    get value() {
        return this._value;
    }
    reset() {
        this._value = this.defaultValue;
        // don't notify listeners
    }
    subscribe(callback, end = true) {
        return this.observable.subscribe(callback, end);
    }
    unsubscribe(id) {
        this.observable.unsubscribe(id);
    }
    unsubscribeAll() {
        this.observable.unsubscribeAll();
    }
    update(value, notifyIfUnchanged = false) {
        if (!notifyIfUnchanged && Sutl.objEquals(this._value, value))
            return;
        const prevValue = this._value;
        this._value = value;
        this.observable.notifyListeners(prevValue);
    }
}
export class StateCollection {
    constructor() {
        this._values = {};
        this.observable = new ObservableCollection();
    }
    clear() {
        Object.keys(this._values).forEach(key => delete this._values[key]);
        // don't notify listeners
    }
    get numSubscriptions() {
        return this.observable.numListeners;
    }
    get values() {
        return this._values;
    }
    subscribe(callback, end = true) {
        return this.observable.subscribe(callback, end);
    }
    unsubscribe(id) {
        this.observable.unsubscribe(id);
    }
    unsubscribeAll() {
        this.observable.unsubscribeAll();
    }
    update(key, value, notifyIfUnchanged = false) {
        if (!notifyIfUnchanged) {
            if (value === undefined) {
                if (!(key in this._values))
                    return;
            }
            else {
                if (Sutl.objEquals(this._values[key], value))
                    return;
            }
        }
        const prevValue = this._values[key];
        if (value === undefined) {
            delete this._values[key];
        }
        else {
            this._values[key] = value;
        }
        this.observable.notifyListeners(key, prevValue);
    }
}
